import { ReleaseNote } from '../types/release-notes/ReleaseNote';

interface CacheEntry {
	data: ReleaseNote[];
	isComplete: boolean;
	lastPage: number;
}

class ReleaseNotesCache {
	private cache = new Map<number, CacheEntry>();

	get(productId: number): CacheEntry | null {
		return this.cache.get(productId) || null;
	}

	set(productId: number, data: ReleaseNote[], isComplete: boolean, lastPage: number): void {
		this.cache.set(productId, {
			data,
			isComplete,
			lastPage
		});
	}

	has(productId: number): boolean {
		return this.cache.has(productId);
	}
}

export const releaseNotesCache = new ReleaseNotesCache();
